/* eslint no-console: 0 */
import * as types from '../../mutation-types';
import CampaignsBroadcast from '../../../api/broadcast/campaignsBroadcast';

const state = {
  isLoading: false,
  isDownloadingEngagement: false,
  isDownloadingFailed: false,
  campaigns: {
    data: [],
    meta: {},
  },
  engagement: {},
};

const getters = {
  getCampaigns(_state) {
    return _state.campaigns;
  },
  getCampaignsEngagement(_state) {
    return _state.engagement;
  },
  uIFlags(_state) {
    return _state.isLoading;
  },
  isDownloadingEngagement(_state) {
    return _state.isDownloadingEngagement;
  },
  isDownloadingFailed(_state) {
    return _state.isDownloadingFailed;
  },
};

export const actions = {
  fetchCampaigns({ commit }, pramsObj) {
    commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS, true);
    CampaignsBroadcast.get(pramsObj).then(data => {
      commit(types.default.SET_BROADCAST_CAMPAIGN, data);
      commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS, false);
    });
  },
  getCampaignsEngagement({ commit }, pramsObj) {
    commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS, true);
    CampaignsBroadcast.getCampaignsEngagement(pramsObj).then(data => {
      commit(types.default.SET_BROADCAST_ENGAGEMENT_CAMPAIGN, data);
      commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS, false);
    });
  },
  downloadEngagement({ commit }, pramsObj) {
    commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS_DOWNLOAD_ENGAGEMENT, true);
    return CampaignsBroadcast.downloadEngagement(pramsObj).then(data => {
      commit(
        types.default.TOGGLE_BROADCAST_CAMPAIGNS_DOWNLOAD_ENGAGEMENT,
        false
      );
    });
  },
  downloadFailed({ commit }, pramsObj) {
    commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS_DOWNLOAD_FAILED, true);
    return CampaignsBroadcast.downloadFailed(pramsObj).then(data => {
      commit(types.default.TOGGLE_BROADCAST_CAMPAIGNS_DOWNLOAD_FAILED, false);
    });
  },
};

const mutations = {
  [types.default.SET_BROADCAST_CAMPAIGN](_state, { data }) {
    _state.campaigns.data = data.payload;
    _state.campaigns.meta = data.meta;
  },
  [types.default.SET_BROADCAST_ENGAGEMENT_CAMPAIGN](_state, { data }) {
    _state.engagement = { ...data };
  },
  [types.default.TOGGLE_BROADCAST_CAMPAIGNS](_state, flag) {
    _state.isLoading = flag;
  },
  [types.default.TOGGLE_BROADCAST_CAMPAIGNS_DOWNLOAD_ENGAGEMENT](_state, flag) {
    _state.isDownloadingEngagement = flag;
  },
  [types.default.TOGGLE_BROADCAST_CAMPAIGNS_DOWNLOAD_FAILED](_state, flag) {
    _state.isDownloadingFailed = flag;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
